import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FlexContainer } from '../../styled/layout.styled';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  height: 24px;
  padding: ${({ padding }) => padding};
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  margin: 0;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  border: solid 1px #c7baf1;
  background-color: transparent;
`;

const StyledCheckbox = styled.div`
  background: ${({ checked }) => (checked ? '#08a57f' : 'transparent')};
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: ${({ checked }) => (checked ? '1px solid transparent' : 'solid 1px #c7baf1')};

  transition: all 150ms;

  ${Icon} {
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
  }
`;

const CheckBox = ({
  checked, onChange, padding, name, children,
}) => (
  <>
    <FlexContainer cursor="pointer" onClick={() => onChange()}>
      <CheckboxContainer padding={padding}>
        <HiddenCheckbox name={name} defaultChecked={checked} />
        <StyledCheckbox checked={checked}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
      {children}
    </FlexContainer>
  </>
);

CheckBox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  padding: PropTypes.string,
};

CheckBox.defaultProps = {
  padding: '',
  children: null,
};

export default CheckBox;
